import { Col, DatePicker, Form } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import { Rule } from 'antd/es/form'

import { TFieldProps } from '..'
import { EConditionGroupType } from '@/interfaces'
import './styles.scss'

import 'dayjs/locale/es'
dayjs.locale('es')

export default function DateFormField({ fieldInfo }: TFieldProps) {
  const setFieldRules = (): Rule[] => {
    const rules: Rule[] = []

    if (fieldInfo.required) {
      rules.push({
        required: true,
        message: 'Este campo es obligatorio',
      })
    }

    return rules
  }

  const handleDisabledDate = (current: Dayjs | null) => {
    if (!current) return false

    if ((fieldInfo.name = 'birthDate')) {
      return current.isAfter(dayjs(), 'day')
    }

    return false
  }

  return (
    <Col
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
      }}
      xxl={4}
      xl={6}
      md={8}
      sm={12}
      xs={24}
    >
      <Form.Item
        className={`date-field ${fieldInfo.className ?? ''}`}
        label={fieldInfo.label}
        name={fieldInfo.name}
        required={fieldInfo.required}
        tooltip={fieldInfo.description}
        rules={setFieldRules()}
      >
        <DatePicker
          disabledDate={handleDisabledDate}
          format='DD/MM/YYYY'
          size='small'
        />
      </Form.Item>
    </Col>
  )
}
